export const customSwitchStyles = (theme) => ({
  '.MuiSwitch-thumb': {
    backgroundColor: theme.palette.error.main,
  },
  '.MuiSwitch-track': {
    backgroundColor: theme.palette.error.light,
  },
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      '+ .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.light,
      },
      '.MuiSwitch-thumb': {
        backgroundColor: theme.palette.primary.main,
      },
      '&.Mui-disabled': {
        '+ .MuiSwitch-track': {
          backgroundColor: theme.palette.action.disabled,
        },
        '.MuiSwitch-thumb': {
          backgroundColor: theme.palette.action.disabledBackground,
        },
      },
    },
  },
});
